import addOutline from '../../node_modules/ionicons/dist/svg/add-outline.svg?raw';
import alertCircleOutline from '../../node_modules/ionicons/dist/svg/alert-circle-outline.svg?raw';
import arrowBackOutline from '../../node_modules/ionicons/dist/svg/arrow-back-outline.svg?raw';
import arrowUpOutline from '../../node_modules/ionicons/dist/svg/arrow-up-outline.svg?raw';
import arrowUndoOutline from '../../node_modules/ionicons/dist/svg/arrow-undo-outline.svg?raw';
import bugOutline from '../../node_modules/ionicons/dist/svg/bug-outline.svg?raw';
import bulbOutline from '../../node_modules/ionicons/dist/svg/bulb-outline.svg?raw';
import businessOutline from '../../node_modules/ionicons/dist/svg/business-outline.svg?raw';
import calendarOutline from '../../node_modules/ionicons/dist/svg/calendar-outline.svg?raw';
import chatbubbleOutline from '../../node_modules/ionicons/dist/svg/chatbubble-outline.svg?raw';
import chatbubbleEllipsesOutline from '../../node_modules/ionicons/dist/svg/chatbubble-ellipses-outline.svg?raw';
import chevronBackOutline from '../../node_modules/ionicons/dist/svg/chevron-back-outline.svg?raw';
import gridOutline from '../../node_modules/ionicons/dist/svg/grid-outline.svg?raw';
import personOutline from '../../node_modules/ionicons/dist/svg/person-outline.svg?raw';
import removeCircleOutline from '../../node_modules/ionicons/dist/svg/remove-circle-outline.svg?raw';
import keypadOutline from '../../node_modules/ionicons/dist/svg/keypad-outline.svg?raw';
import logOutOutline from '../../node_modules/ionicons/dist/svg/log-out-outline.svg?raw';
import telescopeOutline from '../../node_modules/ionicons/dist/svg/telescope-outline.svg?raw';
import checkmarkCircleOutline from '../../node_modules/ionicons/dist/svg/checkmark-circle-outline.svg?raw';
import checkmarkOutline from '../../node_modules/ionicons/dist/svg/checkmark-outline.svg?raw';
import chevronForwardOutline from '../../node_modules/ionicons/dist/svg/chevron-forward-outline.svg?raw';
import closeCircle from '../../node_modules/ionicons/dist/svg/close-circle.svg?raw';
import closeCircleOutline from '../../node_modules/ionicons/dist/svg/close-circle-outline.svg?raw';
import contrastOutline from '../../node_modules/ionicons/dist/svg/contrast-outline.svg?raw';
import cloudOfflineOutline from '../../node_modules/ionicons/dist/svg/cloud-offline-outline.svg?raw';
import documentOutline from '../../node_modules/ionicons/dist/svg/document-outline.svg?raw';
import sendOutline from '../../node_modules/ionicons/dist/svg/send-outline.svg?raw';
import closeOutline from '../../node_modules/ionicons/dist/svg/close-outline.svg?raw';
import copyOutline from '../../node_modules/ionicons/dist/svg/copy-outline.svg?raw';
import ellipsisHorizontalOutline from '../../node_modules/ionicons/dist/svg/ellipsis-horizontal-outline.svg?raw';
import gitCommitOutline from '../../node_modules/ionicons/dist/svg/git-commit-outline.svg?raw';
import playForwardOutline from '../../node_modules/ionicons/dist/svg/play-forward-outline.svg?raw';
import informationCircleOutline from '../../node_modules/ionicons/dist/svg/information-circle-outline.svg?raw';
import moonOutline from '../../node_modules/ionicons/dist/svg/moon-outline.svg?raw';
import sunnyOutline from '../../node_modules/ionicons/dist/svg/sunny-outline.svg?raw';
import exitOutline from '../../node_modules/ionicons/dist/svg/exit-outline.svg?raw';
import flagOutline from '../../node_modules/ionicons/dist/svg/flag-outline.svg?raw';
import constructOutline from '../../node_modules/ionicons/dist/svg/construct-outline.svg?raw';
import createOutline from '../../node_modules/ionicons/dist/svg/create-outline.svg?raw';
import documentTextOutline from '../../node_modules/ionicons/dist/svg/document-text-outline.svg?raw';
import printOutline from '../../node_modules/ionicons/dist/svg/print-outline.svg?raw';
import listOutline from '../../node_modules/ionicons/dist/svg/list-outline.svg?raw';
import ellipseOutline from '../../node_modules/ionicons/dist/svg/ellipse-outline.svg?raw';
import eyeOffOutline from '../../node_modules/ionicons/dist/svg/eye-off-outline.svg?raw';
import eyeOutline from '../../node_modules/ionicons/dist/svg/eye-outline.svg?raw';
import fileTrayOutline from '../../node_modules/ionicons/dist/svg/file-tray-outline.svg?raw';
import fileTrayFullOutline from '../../node_modules/ionicons/dist/svg/file-tray-full-outline.svg?raw';
import settingsOutline from '../../node_modules/ionicons/dist/svg/settings-outline.svg?raw';
import flaskOutline from '../../node_modules/ionicons/dist/svg/flask-outline.svg?raw';
import gitMergeOutline from '../../node_modules/ionicons/dist/svg/git-merge-outline.svg?raw';
import helpCircleOutline from '../../node_modules/ionicons/dist/svg/help-circle-outline.svg?raw';
import hourglassOutline from '../../node_modules/ionicons/dist/svg/hourglass-outline.svg?raw';
import imageOutline from '../../node_modules/ionicons/dist/svg/image-outline.svg?raw';
import keyOutline from '../../node_modules/ionicons/dist/svg/key-outline.svg?raw';
import linkOutline from '../../node_modules/ionicons/dist/svg/link-outline.svg?raw';
import lockClosedOutline from '../../node_modules/ionicons/dist/svg/lock-closed-outline.svg?raw';
import mailOutline from '../../node_modules/ionicons/dist/svg/mail-outline.svg?raw';
import openOutline from '../../node_modules/ionicons/dist/svg/open-outline.svg?raw';
import optionsOutline from '../../node_modules/ionicons/dist/svg/options-outline.svg?raw';
import pauseCircleOutline from '../../node_modules/ionicons/dist/svg/pause-circle-outline.svg?raw';
import pricetagOutline from '../../node_modules/ionicons/dist/svg/pricetag-outline.svg?raw';
import radioButtonOff from '../../node_modules/ionicons/dist/svg/radio-button-off.svg?raw';
import radioButtonOn from '../../node_modules/ionicons/dist/svg/radio-button-on.svg?raw';
import refreshOutline from '../../node_modules/ionicons/dist/svg/refresh-outline.svg?raw';
import returnDownForwardOutline from '../../node_modules/ionicons/dist/svg/return-down-forward-outline.svg?raw';
import saveOutline from '../../node_modules/ionicons/dist/svg/save-outline.svg?raw';
import searchOutline from '../../node_modules/ionicons/dist/svg/search-outline.svg?raw';
import shieldCheckmarkOutline from '../../node_modules/ionicons/dist/svg/shield-checkmark-outline.svg?raw';
// Googles merke på «Logg inn med Google» (DD-79). Ensfarget fra ionicons, så det følger knappens
// tekstfarge og aldri bærer en hex-verdi inn i panelet.
import logoGoogle from '../../node_modules/ionicons/dist/svg/logo-google.svg?raw';
import swapHorizontalOutline from '../../node_modules/ionicons/dist/svg/swap-horizontal-outline.svg?raw';
import timeOutline from '../../node_modules/ionicons/dist/svg/time-outline.svg?raw';
import trashOutline from '../../node_modules/ionicons/dist/svg/trash-outline.svg?raw';
import addCircleOutline from '../../node_modules/ionicons/dist/svg/add-circle-outline.svg?raw';
import arrowForwardCircleOutline from '../../node_modules/ionicons/dist/svg/arrow-forward-circle-outline.svg?raw';
import beakerOutline from '../../node_modules/ionicons/dist/svg/beaker-outline.svg?raw';
import bookmarkOutline from '../../node_modules/ionicons/dist/svg/bookmark-outline.svg?raw';
import pieChartOutline from '../../node_modules/ionicons/dist/svg/pie-chart-outline.svg?raw';
import stopCircleOutline from '../../node_modules/ionicons/dist/svg/stop-circle-outline.svg?raw';
// H3.3: kildekatalogen (databasen), «Må bygges» (hammeren), «Varsle meg» (bjella), «Slik har andre
// tallfestet» (boka) og «Jeg har data på dette» (søylene) — konseptsidens ikonkart.
import serverOutline from '../../node_modules/ionicons/dist/svg/server-outline.svg?raw';
import hammerOutline from '../../node_modules/ionicons/dist/svg/hammer-outline.svg?raw';
import notificationsOutline from '../../node_modules/ionicons/dist/svg/notifications-outline.svg?raw';
import bookOutline from '../../node_modules/ionicons/dist/svg/book-outline.svg?raw';
import barChartOutline from '../../node_modules/ionicons/dist/svg/bar-chart-outline.svg?raw';
// H3.1: notisen til sluttbrukerne («Hva vi fant ut», «notis til brukerne» i «Til deg»).
import megaphoneOutline from '../../node_modules/ionicons/dist/svg/megaphone-outline.svg?raw';
import warningOutline from '../../node_modules/ionicons/dist/svg/warning-outline.svg?raw';
// H3.2: møtet — skjermen i rommet, gripeflaten i agendaen, sitatene, «Gi videre», «Ikke i dag» og tallene.
import tvOutline from '../../node_modules/ionicons/dist/svg/tv-outline.svg?raw';
import reorderTwoOutline from '../../node_modules/ionicons/dist/svg/reorder-two-outline.svg?raw';
import chatboxEllipsesOutline from '../../node_modules/ionicons/dist/svg/chatbox-ellipses-outline.svg?raw';
import arrowRedoOutline from '../../node_modules/ionicons/dist/svg/arrow-redo-outline.svg?raw';
import playSkipForwardOutline from '../../node_modules/ionicons/dist/svg/play-skip-forward-outline.svg?raw';
import statsChartOutline from '../../node_modules/ionicons/dist/svg/stats-chart-outline.svg?raw';
import chevronUpOutline from '../../node_modules/ionicons/dist/svg/chevron-up-outline.svg?raw';
import chevronDownOutline from '../../node_modules/ionicons/dist/svg/chevron-down-outline.svg?raw';

/**
 * Ionicons som inline SVG, med navnene fra ikonkartet i admin-innboks.jsx og
 * `submissionStatus` i theme/theme.ts (brand-ui-guidelines: «Emoji brukes aldri i
 * implementasjonen»). Statiske, bundlede filer — ikke brukerinnhold. Stiene går via
 * node_modules fordi pakkens `exports` ikke eksponerer SVG-filene.
 */
/** Ionicons legger en <title> i hver SVG; den ville lest opp «Bug» foran «Feil». Ikonet er dekorativt, teksten står ved siden av. */
const utenTittel = (svg: string) => svg.replace(/<title>[\s\S]*?<\/title>/g, '');

const IKONER: Record<string, string> = Object.fromEntries(
  Object.entries({
  'add-outline': addOutline,
  'arrow-back-outline': arrowBackOutline,
  // M4.12 (DD-74): stripa over lista, «↑ 3 nye innspill».
  'arrow-up-outline': arrowUpOutline,
  'arrow-undo-outline': arrowUndoOutline,
  'bug-outline': bugOutline,
  'bulb-outline': bulbOutline,
  // R4.3, skallets ikonkart (admin-skall.jsx): Organisasjon, rommet Innspill, rommet
  // Hypoteser (DD-63 — lyspæren er ønskets og brukes aldri om et rom), «Logg ut» og
  // «Tastaturkart» i «⋯».
  'business-outline': businessOutline,
  'calendar-outline': calendarOutline,
  'chatbubble-outline': chatbubbleOutline,
  // M4.8, ikonkartet i admin-panelbrukere.jsx: Medlem (personen), Behandler (boblen MED linjer —
  // rommet Innspill har den tomme, så de er to ikoner), Ingen, Alle rom / Alt, og tilbakepilen
  // i stripen og over tittelen på Organisasjons undersider.
  'chatbubble-ellipses-outline': chatbubbleEllipsesOutline,
  'chevron-back-outline': chevronBackOutline,
  'grid-outline': gridOutline,
  'person-outline': personOutline,
  'remove-circle-outline': removeCircleOutline,
  'keypad-outline': keypadOutline,
  'log-out-outline': logOutOutline,
  'telescope-outline': telescopeOutline,
  'checkmark-circle-outline': checkmarkCircleOutline,
  // Hakemerket i bryterens knott (DD-08 presisert, P1): tilstanden som ikon + posisjon.
  'checkmark-outline': checkmarkOutline,
  // Fylt, ikke kontur: programstatusen «Avbrutt» er den eneste fylte pillen (theme.ts).
  'chevron-forward-outline': chevronForwardOutline,
  'close-circle': closeCircle,
  'close-circle-outline': closeCircleOutline,
  'contrast-outline': contrastOutline,
  // R2.3: «Kopier» per token, «⋯» på 400 px der «Avbryt programmet» ligger, og «Fjern» på
  // en oppgaverad — nøytralt kryss, ikke det røde `close-circle-outline` (DD-53).
  'close-outline': closeOutline,
  // H2.2, ikonkartet i hypotese-innsending.jsx: «ikke lagret» (☁), utkastets pille (📄) og
  // «Send inn» (➤).
  'cloud-offline-outline': cloudOfflineOutline,
  'document-outline': documentOutline,
  'send-outline': sendOutline,
  // H3.1: notisen tilbake til sluttbrukerne — samme ikon i forhåndsvisningen, kvitteringen og merket i «Til deg».
  'megaphone-outline': megaphoneOutline,
  'copy-outline': copyOutline,
  'ellipsis-horizontal-outline': ellipsisHorizontalOutline,
  // F30: steg lenger fram i «Hele flyten» og via-linja.
  'git-commit-outline': gitCommitOutline,
  'play-forward-outline': playForwardOutline,
  'information-circle-outline': informationCircleOutline,
  'moon-outline': moonOutline,
  'sunny-outline': sunnyOutline,
  'construct-outline': constructOutline,
  'create-outline': createOutline,
  'document-text-outline': documentTextOutline,
  'print-outline': printOutline,
  // Registeret i rommet Hypoteser (H2.3, `admin-hypoteser.jsx` ☰).
  'list-outline': listOutline,
  'ellipse-outline': ellipseOutline,
  'exit-outline': exitOutline,
  'flag-outline': flagOutline,
  'eye-off-outline': eyeOffOutline,
  'eye-outline': eyeOutline,
  // R4.4, sidenes ikoner i sidemenyen og faneraden (ikonkartet i admin-skall.jsx): brettet
  // for Innboks, det fylte for Saker, ⚠ for Kjente feil, kolben for Betaprogram og tannhjulet
  // for Innstillinger. Lyspæren er ønskets og brukes aldri om en side (DD-63).
  'file-tray-outline': fileTrayOutline,
  'file-tray-full-outline': fileTrayFullOutline,
  'settings-outline': settingsOutline,
  'flask-outline': flaskOutline,
  'git-merge-outline': gitMergeOutline,
  'help-circle-outline': helpCircleOutline,
  'hourglass-outline': hourglassOutline,
  'image-outline': imageOutline,
  'key-outline': keyOutline,
  'link-outline': linkOutline,
  'lock-closed-outline': lockClosedOutline,
  'mail-outline': mailOutline,
  'open-outline': openOutline,
  'options-outline': optionsOutline,
  'pause-circle-outline': pauseCircleOutline,
  'pricetag-outline': pricetagOutline,
  // Avslagskodene er ETT radiovalg (DD-09): valgt og ikke valgt skilles på form, ikke bare farge.
  'radio-button-off': radioButtonOff,
  'radio-button-on': radioButtonOn,
  'refresh-outline': refreshOutline,
  'return-down-forward-outline': returnDownForwardOutline,
  'save-outline': saveOutline,
  'search-outline': searchOutline,
  'shield-checkmark-outline': shieldCheckmarkOutline,
  'logo-google': logoGoogle,
  'swap-horizontal-outline': swapHorizontalOutline,
  'time-outline': timeOutline,
  'trash-outline': trashOutline,
  'warning-outline': warningOutline,
  'alert-circle-outline': alertCircleOutline,
  // H2.3, hypotesestatusene (hypothesisStatus i theme.ts) og «Til deg» i rommet Hypoteser
  // (ikonkartet i admin-hypoteser.jsx): begeret for Testes, aldri kolben (DD-63).
  'add-circle-outline': addCircleOutline,
  'arrow-forward-circle-outline': arrowForwardCircleOutline,
  'beaker-outline': beakerOutline,
  'bookmark-outline': bookmarkOutline,
  'pie-chart-outline': pieChartOutline,
  'stop-circle-outline': stopCircleOutline,
  'server-outline': serverOutline,
  'hammer-outline': hammerOutline,
  'notifications-outline': notificationsOutline,
  'book-outline': bookOutline,
  'bar-chart-outline': barChartOutline,
    'tv-outline': tvOutline,
    'reorder-two-outline': reorderTwoOutline,
    'chatbox-ellipses-outline': chatboxEllipsesOutline,
    'arrow-redo-outline': arrowRedoOutline,
    'play-skip-forward-outline': playSkipForwardOutline,
    'stats-chart-outline': statsChartOutline,
    'chevron-up-outline': chevronUpOutline,
    'chevron-down-outline': chevronDownOutline,
  }).map(([navn, svg]) => [navn, utenTittel(svg)]),
);

export type IkonNavn = keyof typeof IKONER;

/** Dekorativt ikon — alltid ved siden av tekst, aldri alene (farge og form bærer ikke mening alene). */
export function Ikon({ navn, className }: { navn: string; className?: string }) {
  const svg = IKONER[navn];
  if (!svg) throw new Error(`[innspel] Ikonet «${navn}» er ikke tatt med i Ikon.tsx.`);
  return <span aria-hidden="true" className={className ? `panel-ikon ${className}` : 'panel-ikon'} dangerouslySetInnerHTML={{ __html: svg }} />;
}
